<template>
  <div class="flex-grow">
    <div class="flex mt-6 mb-10">
      <div class="w-full md:w-2/3 md:mx-auto md:max-w-md px-4">
        <h1 class="my-6">
          Reset Password
        </h1>
        <form
          @submit.prevent="send"
          @keydown="form.onKeydown($event)"
        >
          <alert-success
            :form="form"
            :message="status"
            class="mb-4"
          />

          <!-- Email -->
          <text-input
            name="email"
            :form="form"
            label="Email"
            :required="true"
          />

          <!-- Submit Button -->
          <v-button
            class="w-full"
            :loading="form.busy"
          >
            Send Password Reset Link
          </v-button>
        </form>
      </div>
    </div>
    <airtable-forms-footer />
  </div>
</template>

<script setup>
definePageMeta({
  middleware: 'guest',
})
defineRouteRules({
  swr: 3600,
})
useAirtableFormsSeoMeta({
  title: 'Reset your Password',
})

const status = ref('')
const form = useForm({
  email: '',
})

async function send() {
  await form.post('/password/email').then((response) => {
    status.value = response.status
    form.reset()
  })
}
</script>
